export const glossary = [
  { term: "Atropelar (Trample)", category: "Mecânica", definition: "Dano excedente ao matar uma criatura bloqueadora é causado ao jogador ou planeswalker defensor." },
  { term: "Vínculo com a Vida (Lifelink)", category: "Mecânica", definition: "Dano causado por esta criatura também faz você ganhar a mesma quantidade de vida." },
  { term: "Ímpeto (Haste)", category: "Mecânica", definition: "A criatura pode atacar ou ser virada no turno em que entra sob seu controle." },
  { term: "Vigilância (Vigilance)", category: "Mecânica", definition: "Atacar com esta criatura não faz com que ela seja virada." },
  { term: "Ameaçar (Menace)", category: "Mecânica", definition: "Esta criatura não pode ser bloqueada, exceto por duas ou mais criaturas." }
];

export const faq = [
  { q: "Como funciona a pilha?", a: "A última mágica ou habilidade a entrar é a primeira a ser resolvida (Last-In, First-Out)." },
  { q: "Posso responder a uma terra entrando em jogo?", a: "Não. Jogar uma terra não usa a pilha e não pode ser respondido." }
];
